
import { defineComponent } from "vue";

export default defineComponent({
  data() {
    return {
      showPlaceholder: false,
    };
  },
  mounted() {
    setTimeout(() => {
      this.showPlaceholder = true;
    }, 250);
  },
});
